import { ExportOutlined } from '@ant-design/icons';
import { Button } from 'antd';

/**
 * Seçilen grubun üyelerini read-only olarak listeler.
 * @param {Object} props
 * @param {{ id: number, label: string }[]} props.members - Grup üyeleri
 */
function GroupMemberList({ members }) {
  return (
    <div>
      <div className="gx-mb-2" style={{ fontWeight: 500 }}>
        Grup Maddeleri ({members.length})
      </div>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0, maxHeight: 300, overflowY: 'auto' }}>
        {members.map((member) => (
          <li
            key={member.id}
            className="gx-d-flex gx-align-items-center gx-justify-content-between gx-mb-1 gx-border gx-p-1"
            style={{ borderRadius: '6px', backgroundColor: 'white' }}
          >
            <div style={{ transform: 'translateY(1.5px)' }}>{member.label}</div>
            <a
              href={`/madde-detay/${member.id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                size="small"
                type="link"
                className="gx-mb-0 gx-d-flex gx-align-items-center gx-justify-content-center"
                icon={<ExportOutlined style={{ fontSize: 14 }} />}
              />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default GroupMemberList;
